import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {PreviewTranslation} from "../../models/preview-translation";
import {Observable} from "rxjs";
import {GeneralTranslation} from "../../models/general-translation";
import {SystemProperties} from "../../models/system-properties";
import Helpers from "../../utils/helpers";

@Injectable()
export class PreviewTranslationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public setPreviewTranslation(previewTranslation: PreviewTranslation) {
    Helpers.trimRecursiveObj(previewTranslation);
    const body = JSON.stringify(previewTranslation);
    return this.http.put(this.baseUrl + "translation/general", body, {responseType: "text"});
  }

  public saveTranslation(serviceId: string, translation: GeneralTranslation): Observable<GeneralTranslation> {
    Helpers.trimRecursiveObj(translation);
    const body = JSON.stringify(translation);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/local_translation", body) as Observable<GeneralTranslation>;
  }
  public replaceOrCreateTranslation(serviceId: string, translation: GeneralTranslation): Observable<GeneralTranslation> {
    Helpers.trimRecursiveObj(translation);
    const body = JSON.stringify(translation);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/replace_or_create", body) as Observable<GeneralTranslation>;
  }
  public saveGlobalTranslation(translation: GeneralTranslation): Observable<GeneralTranslation>  {
    Helpers.trimRecursiveObj(translation);
    const body = JSON.stringify(translation);
    return this.http.put(this.baseUrl + "translation/general/global_translation", body) as Observable<GeneralTranslation>;
  }
  public reloadGlobalTranslations() {
    return this.http.post(this.baseUrl + "translation/general/reload_global", undefined, {responseType: "text"});
  }
  public reloadTranslationsCache() {
    return this.http.post(this.baseUrl + "translation/general/reload_cache", undefined);
  }
  public updateSystemProperties(serviceProperties: SystemProperties) {
    Helpers.trimRecursiveObj(serviceProperties);
    const body = JSON.stringify(serviceProperties);
    return this.http.put(this.baseUrl + "translation/general/properties", body);
  }
  public getTranslationSettingsStates() {
    return this.http.get(this.baseUrl + "translation/general/properties");
  }
  public saveTranslations(serviceId: string, translation: GeneralTranslation): Observable<any>  {
    Helpers.trimRecursiveObj(translation);
    const body = JSON.stringify(translation);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/translations", body);
  }
  public getTranslationsPage(serviceId: string, page: number, translationsPerPage: number, filters: string, form: any): Observable<any[]> {
    const suffix = !!form ? "&formId=" + form.id + "&formType=" + form.type : "";
    return this.http.get(this.baseUrl + "service/" + serviceId + "/translations?pageNo=" + page + "&pageSize=" + translationsPerPage + "&type=" + filters + suffix) as Observable<any[]>;
  }

  public getServiceComponentTranslations(serviceId: string, componentKey: string, form: any): Observable<any[]> {
    const suffix = !!form ? "?formId=" + form.id + "&formType=" + form.type : "";
    return this.http.get(this.baseUrl + "service/" + serviceId + "/component_translations/" + componentKey + suffix) as Observable<any[]>;
  }

  public searchTranslations(serviceId: string, searchString: string, filters: string, page: number, translationsPerPage: number, exactMatch: boolean, form: any) {
    const suffix = !!form ? "&formId=" + form.id + "&formType=" + form.type : "";

    return this.http.get(this.baseUrl + "service/" + serviceId + "/search_translations?searchString=" +
      encodeURIComponent(searchString) + "&pageNo=" + page + "&pageSize=" + translationsPerPage + "&type=" + filters + "&exactMatch=" + exactMatch + suffix) as Observable<any[]>;
  }

  public deleteTranslationsByIds(ids: string[]) {
    const body = JSON.stringify(ids);
    return this.http.post(this.baseUrl + "translation/delete", body);
  }
  public deleteGlobalTranslationsById(id: string) {
    return this.http.post(this.baseUrl + "translation/delete/global/" + id, undefined);
  }

}
